const briefcase = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11.33 3V.5H4.67V3H.5v12.5h15V3zm-5-.83h3.34V3H6.33zm7.5 6.66H9.67v1.67H6.33V8.83H2.17V7.17h11.66z"/></svg>',
};

export { briefcase as default };
